import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { theme } from '../theme/theme'
import { BodyXl } from '../components/styles/Typography'

export const LoggedOut = () => {
  const { t } = useTranslation()

  return (
    <LoggedOutWrapper>
      <BodyXl>{t('common.loggedOut.message')}</BodyXl>
    </LoggedOutWrapper>
  )
}

const LoggedOutWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.color.plum};
`
